export default "__VITE_ASSET__161458bf__"